import React from 'react'
import { useNavigate } from 'react-router-dom';

const Step_five = ({ prevStep, nextStep, allMaterial, onFilterChange }) => {
      const navigate = useNavigate();
    return (
        <>
            <section className='quizformsection'>

                <div className='navigationdiv'>
                    <div className='row'>
                        <div className='col-12 text-center'>
                            <p className='formstepps'>5/05</p>
                        </div>
                        <div className='col-12 text-center'>
                            <div className='formtitlediv'>
                                <h2 className='formtitle'>Which materials do you like?</h2>
                                <button className="backbtn" type="button" onClick={prevStep} >
                                    <img className='backicon' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/backbtn.png'} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='productsdiv'>
                    <div className='row justify-content-center'>
                        {allMaterial?.map((data) => (
                            <div className='col-lg-4 col-sm-6  mb-3'>
                                <div className='productcard' onClick={() => { onFilterChange("material", { id: data?.id, name: data.name }); navigate("/all-products") }}>
                                    <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                    <div className='oevrlaycont'>
                                        <div className='prodimgdiv'>
                                            <img className='prod_img' src={process.env.REACT_APP_IMAGE_URL + data?.image} />
                                        </div>
                                        <p className='prodname'>{data?.name}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/gog1.png'} />
                                    </div>
                                    <p className='prodname'>Acetate</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/gog2.png'} />
                                    </div>
                                    <p className='prodname'>Metal</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-4 col-sm-6  mb-3'>
                            <div className='productcard'>
                                <img className='bgimg' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/frame1.png'} />

                                <div className='oevrlaycont'>
                                    <div className='prodimgdiv'>
                                        <img className='prod_img' src={process.env.PUBLIC_URL + '/assets/images/quick-quiz/gog3.png'} />
                                    </div>
                                    <p className='prodname'>Mixed</p>
                                </div>
                            </div>
                        </div> */}


                    </div>
                </div>

                <div className='nextbuttondiv'>
                    <button className='nextbtn' onClick={()=>navigate("/all-products")}>No preference</button>
                </div>


            </section>
        </>
    )
}

export default Step_five